import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Flex } from "antd";
import {
  FormInput,
  FormDatePicker,
  AppForm,
  LanguageSelect,
  SettingsSectionTitle,
  AppButton,
  AppTitle,
} from "@/shared/Components";
import { installationConfig } from "@/shared/constants/installation-config";
import { ModalWrapper } from "@/features/modals/ModalWrapper";
import { AlertYellowIcon } from "@/shared/icons/AlertYellowIcon";
import { useProfileForm } from "../model";
import styles from "./styles.module.scss";

export const ProfileForm = () => {
  const { t } = useTranslation();
  const {
    formApi,
    emailConfirmed,
    isModalOpen,
    handleCloseModal,
    handleConfirmEmail,
    isSendingConfirmEmailCode,
    isConfirmingEmail,
    confirmEmailCodeDisabled,
    handleConfirmEmailCode,
    handleChangeConfirmEmailCode,
  } = useProfileForm();

  return (
    <Flex className={styles.root} vertical gap={12}>
      <SettingsSectionTitle title={t("settingsPage.general.personalInfo")} />
      <AppForm formApi={formApi} onSubmit={() => {}} className={styles["info-inputs"]}>
        <FormInput
          className={styles.input}
          name="firstName"
          placeholder={t("registrationPage.userInfoStep.firstName")}
          disabled
        />
        <FormInput
          className={styles.input}
          name="lastName"
          placeholder={t("registrationPage.userInfoStep.lastName")}
          disabled
        />
        <FormInput
          className={styles.input}
          name="mobilePhone"
          placeholder={t("settingsPage.general.phone")}
          disabled
        />
        <Flex gap={12}>
          <FormInput
            className={styles.input}
            name="email"
            placeholder={t("settingsPage.general.email")}
            disabled
            suffix={
              <span
                className={classNames(styles["email-suffix"], {
                  [styles["email-suffix--confirmed"]]: emailConfirmed,
                })}
              >
                {emailConfirmed
                  ? t("settingsPage.general.emailConfirmed")
                  : t("settingsPage.general.emailConfirm")}
              </span>
            }
          />
          {!emailConfirmed && (
            <AppButton
              isOutlined
              onClick={handleConfirmEmail}
              loading={isSendingConfirmEmailCode}
              disabled={isSendingConfirmEmailCode}
            >
              {t("common.confirm")}
            </AppButton>
          )}
        </Flex>
        <Flex>
          <FormDatePicker
            className={classNames(styles["birthday-select"], styles.input)}
            placeholder={t("settingsPage.general.birthday")}
            name="birthday"
            disabled
          />
          {installationConfig.name === "Umarta" && <LanguageSelect />}
        </Flex>
      </AppForm>
      <ModalWrapper
        type="save"
        width={400}
        modalTitle={
          <Flex gap={12} align="center">
            <AlertYellowIcon width={64} height={64} />
            <AppTitle size="lg">
              {t("settingsPage.general.confirmEmailModalTitle", {
                email: formApi.getValues("email"),
              })}
            </AppTitle>
          </Flex>
        }
        open={isModalOpen}
        onOk={handleConfirmEmailCode}
        onCancel={handleCloseModal}
        okText={t("common.confirm")}
        okButtonProps={{
          loading: isConfirmingEmail,
          disabled: confirmEmailCodeDisabled,
        }}
        cancelText={t("common.cancel")}
      >
        <AppForm formApi={formApi}>
          <FormInput
            className={styles["confirm-email-code"]}
            name="confirmEmailCode"
            placeholder={t("settingsPage.general.confirmEmailCodePlaceholder")}
            customOnChange={handleChangeConfirmEmailCode}
          />
        </AppForm>
      </ModalWrapper>
    </Flex>
  );
};
